import { render, staticRenderFns } from "./ChromePdfPrinter.vue?vue&type=template&id=2a7a84ea&scoped=true&"
import script from "./ChromePdfPrinter.vue?vue&type=script&lang=ts&"
export * from "./ChromePdfPrinter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a84ea",
  null
  
)

export default component.exports